import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

function DigitalWrapper({ giftWrapperUrl }) {
  return <S.DigitalWrapper src={giftWrapperUrl} />;
}

DigitalWrapper.propTypes = {
  giftWrapperUrl: PropTypes.string
};

export { DigitalWrapper };
